import type { I18nFn } from '#/i18n/types/I18nFn';

export enum InternshipFunction {
  ACCOUNTING_FINANCE = 'ACCOUNTING_FINANCE',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  ADVOCACY = 'ADVOCACY',
  BUSINESS_DEVELOPMENT = 'BUSINESS_DEVELOPMENT',
  CITIZENSHIP = 'CITIZENSHIP',
  COMMUNITY_BELONGING = 'COMMUNITY_BELONGING',
  COMMUNITY_ENGAGEMENT_OUTREACH = 'COMMUNITY_ENGAGEMENT_OUTREACH',
  CONSERVATION = 'CONSERVATION',
  CORPORATE_RESPONSIBILITY = 'CORPORATE_RESPONSIBILITY',
  DATA_ENTRY_ANALYSIS = 'DATA_ENTRY_ANALYSIS',
  DEVELOPMENT_FUNDRAISING = 'DEVELOPMENT_FUNDRAISING',
  DIVERSITY_EQUITY_INCLUSION = 'DIVERSITY_EQUITY_INCLUSION',
  EMPLOYEE_ENGAGEMENT = 'EMPLOYEE_ENGAGEMENT',
  EVENTS = 'EVENTS',
  GRANT_WRITING = 'GRANT_WRITING',
  HUMAN_RESOURCES = 'HUMAN_RESOURCES',
  LEGAL = 'LEGAL',
  MARKETING_COMMUNICATIONS = 'MARKETING_COMMUNICATIONS',
  OPERATIONS = 'OPERATIONS',
  PARTNERSHIPS = 'PARTNERSHIPS',
  PHOTOGRAPHY_MEDIA_DESIGN = 'PHOTOGRAPHY_MEDIA_DESIGN',
  PROGRAM_MANAGEMENT = 'PROGRAM_MANAGEMENT',
  PUBLIC_RELATIONS = 'PUBLIC_RELATIONS',
  RESEARCH = 'RESEARCH',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  STRATEGY = 'STRATEGY',
  SUSTAINABILITY = 'SUSTAINABILITY',
  TEACHING_INSTRUCTION = 'TEACHING_INSTRUCTION',
  TECHNOLOGY_IT = 'TECHNOLOGY_IT',
  WRITING_JOURNALISM = 'WRITING_JOURNALISM',
}

export function INTERNSHIP_FUNCTIONS(i18n: I18nFn) {
  return {
    [InternshipFunction.ACCOUNTING_FINANCE]: i18n('Accounting & Finance'),
    [InternshipFunction.ADMINISTRATIVE]: i18n('Administrative'),
    [InternshipFunction.ADVOCACY]: i18n('Advocacy'),
    [InternshipFunction.BUSINESS_DEVELOPMENT]: i18n('Business Development'),
    [InternshipFunction.CITIZENSHIP]: i18n('Citizenship'),
    [InternshipFunction.COMMUNITY_BELONGING]: i18n('Community Belonging'),
    [InternshipFunction.COMMUNITY_ENGAGEMENT_OUTREACH]: i18n(
      'Community Engagement/Outreach',
    ),
    [InternshipFunction.CONSERVATION]: i18n('Conservation'),
    [InternshipFunction.CORPORATE_RESPONSIBILITY]: i18n(
      'Corporate Responsibility',
    ),
    [InternshipFunction.DATA_ENTRY_ANALYSIS]: i18n('Data Entry & Analysis'),
    [InternshipFunction.DEVELOPMENT_FUNDRAISING]: i18n(
      'Development/Fundraising',
    ),
    [InternshipFunction.DIVERSITY_EQUITY_INCLUSION]: i18n(
      'Diversity, Equity & Inclusion',
    ),
    [InternshipFunction.EMPLOYEE_ENGAGEMENT]: i18n('Employee Engagement'),
    [InternshipFunction.EVENTS]: i18n('Events'),
    [InternshipFunction.GRANT_WRITING]: i18n('Grant Writing'),
    [InternshipFunction.HUMAN_RESOURCES]: i18n('Human Resources'),
    [InternshipFunction.LEGAL]: i18n('Legal'),
    [InternshipFunction.MARKETING_COMMUNICATIONS]: i18n(
      'Marketing & Communications',
    ),
    [InternshipFunction.OPERATIONS]: i18n('Operations'),
    [InternshipFunction.PARTNERSHIPS]: i18n('Partnerships'),
    [InternshipFunction.PHOTOGRAPHY_MEDIA_DESIGN]: i18n(
      'Photography, Media & Design',
    ),
    [InternshipFunction.PROGRAM_MANAGEMENT]: i18n('Program Management'),
    [InternshipFunction.PUBLIC_RELATIONS]: i18n('Public Relations'),
    [InternshipFunction.RESEARCH]: i18n('Research'),
    [InternshipFunction.SOCIAL_MEDIA]: i18n('Social Media'),
    [InternshipFunction.STRATEGY]: i18n('Strategy'),
    [InternshipFunction.SUSTAINABILITY]: i18n('Sustainability'),
    [InternshipFunction.TEACHING_INSTRUCTION]: i18n('Teaching & Instruction'),
    [InternshipFunction.TECHNOLOGY_IT]: i18n('Technology/IT'),
    [InternshipFunction.WRITING_JOURNALISM]: i18n('Writing or Journalism'),
  } satisfies Record<InternshipFunction, string>;
}

export const INTERNSHIP_FUNCTIONS_RADIO_OR_SELECT_OPTIONS = (i18n: I18nFn) =>
  Object.entries(INTERNSHIP_FUNCTIONS(i18n))
    .toSorted(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      value: key,
      label: value,
    }));

export const INTERNSHIP_FUNCTIONS_CHECKBOX_OPTIONS = (i18n: I18nFn) =>
  Object.entries(INTERNSHIP_FUNCTIONS(i18n))
    .toSorted(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      name: key,
      label: value,
    }));
